import _ from 'lodash';

export default class ValidationUtil {
  static areFieldsFilledOut(fieldToValue, requiredFields) {
    let result = true;
    requiredFields.forEach((requiredField) => {
      // Are all of the required fields in the object?
      result = result && Object.keys(fieldToValue).includes(requiredField);

      // Are all of the attributes in the field valid?
      const attribute = _.get(fieldToValue, requiredField, null);

      if (attribute instanceof Date) {
        return true;
      }
      result = result && ((_.isArray(attribute) || _.isObject(attribute))
        ? !_.isEmpty(attribute)
        : (!_.isNull(attribute) && attribute !== '' && attribute !== undefined));
    });

    return result;
  }

  static shouldShowFileViewer(user, category, prefix = '') {
    const data = _.get(user.uploads, category, false);
    if (_.isArray(data)) {
      return _.find(data, (item) => {
        return item.key.includes(prefix);
      });
    }
    return data && !_.isEmpty(data);
  }

  static getS3Key(user, category, prefix = '') {
    const data = _.get(user.uploads, category, '');
    let key = '';
    if (_.isArray(data)) {
      data.forEach((item) => {
        if (item.key.includes(prefix)) {
          key += item.key;
        }
      });
    } else {
      key += data.key;
    }

    return key;
  }

  static verifyUserBasicInfoCompleted(user) {
    const basicInfoFields = ['firstName', 'lastName', 'dateOfBirth', 'gender'];

    const missingFields = [];

    basicInfoFields.map((fieldName) => {
      if (!user[fieldName] || user[fieldName].length === 0) missingFields.push(fieldName);
    });

    return { isComplete: missingFields.length === 0, missingFields };
  }

  static isBasicProfileCompleted(user) {
    return this.verifyUserBasicInfoCompleted(user).isComplete;
  }

  static verifyMissionSignupFullyCompleted(user, missionId, missionGoer) {
    // const waivers = _.get(user, 'uploads.waivers', []);
    // const requiredFields = ['selectedVaccinations', 'scrubTopSize', 'scrubBottomSize', 'airlineInfo'];
    //
    // const numberOfWaiversForMission = _.filter(waivers, (waiver) => {
    //   return waiver.key.includes(missionId);
    // }).length;
    // return this.areFieldsFilledOut(missionGoer, requiredFields)
    //   && numberOfWaiversForMission === 2
    //   && this.isProfileCompleted(user);
    return this.isMissionGoerApplicationCompleted(user, missionId, missionGoer)
      && this.isProfileCompleted(user);
  }

  static isMissionGoerApplicationCompleted(user, missionId, missionGoer) {
    const waivers = _.get(user, 'uploads.waivers', []);
    const requiredFields = ['selectedVaccinations', 'scrubTopSize', 'scrubBottomSize', 'airlineInfo'];

    const numberOfWaiversForMission = _.filter(waivers, (waiver) => {
      return waiver.key.includes(missionId);
    }).length;
    return this.areFieldsFilledOut(missionGoer, requiredFields)
      && numberOfWaiversForMission === 2;
  }

  static isProfileCompleted(user) {
    const uploads = _.get(user, 'uploads', false);
    if (!uploads) {
      return false;
    }

    const requiredDocuments = ['passport', 'certifications', 'stateLicenses', 'resume'];
    const result = this.areFieldsFilledOut(uploads, requiredDocuments);

    return result;
  }
}
